/* eslint-disable react/jsx-no-useless-fragment */
import { Pagination, Spin } from 'antd';
import React from 'react';
import { fetchElemento } from '../../actions/elemento';
import Accordion from '../../components/accordion';
import Bread from '../../components/breadcrumb';
import Card from '../../components/card';
import { usePagination } from '../../hooks/usePagination';
import { parserElementos } from '../../utils/parsers/elemento';
import { columnsElementos, parserDataTabla } from '../../utils/parsers/table';
import { routeElemento } from '../../utils/routesBread';
import AccordionElemento from './accordion-elemento';

const Elemento = () => {
  const {
    dataSource, total, handlePage, page, isLoading, perPage
  } = usePagination(fetchElemento, 'elemento');
  return (
    <div className="page-container">
      <div className="header-nav">
        <Bread routes={routeElemento} />
      </div>
      <div className="page-container__box">
        <Accordion keyPanel="elementos" header="Elementos">
          {isLoading
            ? (
              <div className="container-spin">
                <Spin tip="Cargando..." />
              </div>
            )
            : (
              <>
                {dataSource
              && dataSource.length !== 0 ? (
                    dataSource.map((item) => (
                      <div key={parserElementos(item).id}>
                        <Card
                          columns={columnsElementos}
                          data={[parserDataTabla(item)]}
                          header={item.nombre}
                          route="info-elemento"
                        />
                        <AccordionElemento data={item} />
                      </div>
                    ))
                  ) : <p className="text-nothing">No hay datos para mostrar</p>}
              </>
            )}
        </Accordion>
        {dataSource
        && (
        <div className="page-container__pagination">
          <Pagination 
            current={page} 
            onChange={handlePage} 
            total={total}
            pageSize={perPage}
            showSizeChanger={false}
          />
        </div>
        )}
      </div>
    </div>
  );
};

export default Elemento;
